export const styles = (theme) => ({
    button: {
        color: "white",
        margin: "1.5rem 0.5rem 0.5rem 0",
        fontSize: "1.0625rem",
        fontFamily: "newsGothic_demi,Arial,Verdana,Helvetica,sans-serif",
        fontWeight: 400,
        backdropFilter: "blur(3px)",
        "&:hover": {
            backgroundColor: "#009",
            borderColor: "#009",
            color: "white",
        },
        padding: "3px 12px",
        // borderRadius: 0,
        border: "1px solid white",
        backgroundColor: "unset",
        textTransform: "none" as const,

        "&.Mui-disabled": {
            borderColor: "darkgray"
        }
    }
});
